import { Injectable } from "@angular/core";
import { BACKEND_URI } from "../config/config-vars";
import { HttpClient, HttpParams } from "@angular/common/http";
import { LoginService } from "./login.service";
import { firstValueFrom } from "rxjs";
import { Location } from "../models/location.model";
import { Board } from "../models/board.model";

const BASE_URL = `${BACKEND_URI}/api/location`;
const GET_ALL_URL = BASE_URL;
const GET_LATEST_URL = `${BASE_URL}/latest`;
const GET_BOARDS_BY_LOCATION_URL = (locationId: string) => `${BACKEND_URI}/api/location/${locationId}/boards`;
const INSERT_URL = BASE_URL;
const UPDATE_URL = (id) => `${BASE_URL}/${id}`;
const GET_BY_ID_URL = (id) => `${BASE_URL}/${id}`;
const DELETE_BY_ID_URL = (id) => `${BASE_URL}/${id}`;



@Injectable({providedIn: 'root'})
export class LocationService {

    constructor(private http: HttpClient, private loginService: LoginService){}

async getAll(includeSalesOutlets = true): Promise<Location[]> {
  if (this.loginService.isloggedIn) {
    const params = new HttpParams().set('includeSalesOutlets', includeSalesOutlets ? 'true' : 'false');
    return await firstValueFrom(
      this.http.get<Location[]>(GET_ALL_URL, { params })
    );
  }
}

    async getLatest(): Promise<Location[]> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<Location[]>(GET_LATEST_URL)
            );
        }
    }

    async getBoardsByLocationId(locationId: string): Promise<Board[]> {
        if (!this.loginService.isloggedIn) {
            return [];
        }
        
        try {
            return await firstValueFrom(
                this.http.get<Board[]>(GET_BOARDS_BY_LOCATION_URL(locationId))
            );
        } catch (error) {
            console.error('Error fetching boards by location:', error);
            return [];
        }
    }

    async getById(id): Promise<Location> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<Location>(GET_BY_ID_URL(id))
            );
        }
    }
    async create(data: Location): Promise<Location> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.post<Location>(INSERT_URL, data)
            );
        }
    }
async update(id, data: Location): Promise<Location> {
    if (this.loginService.isloggedIn) {
        console.log("Sending update payload:", data); // 👈 Add this
        return await firstValueFrom(
            this.http.put<Location>(UPDATE_URL(id), data)
        );
    }
}


    async delete(id): Promise<void> {
        if(this.loginService.isloggedIn) {
            try{
                await firstValueFrom(
                    this.http.delete(DELETE_BY_ID_URL(id))
                );
            } catch(err) {}
           
        }
    }

async setSalesOutlet(id: string, value: boolean): Promise<Location> {
  const params = new HttpParams().set('value', value ? 'true' : 'false');
  return await firstValueFrom(this.http.patch<Location>(`${BASE_URL}/${id}/sales-outlet`, null, { params }));
}



    
    

    
}